export const ROUTES = {
  // Auth
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',

  // Admin
  ADMIN: '/admin',
  ADMIN_TASKS: '/admin/tasks',
  ADMIN_SHOWS: '/admin/shows',
  ADMIN_SHOW_DETAIL: '/admin/shows/:id',
  ADMIN_EPISODE_DETAIL: '/admin/shows/:showId/episodes/:id',
  ADMIN_WORKFLOWS: '/admin/workflows',
  ADMIN_PLANNER: '/admin/planner',
  ADMIN_WORKFLOW_DETAIL: '/admin/workflows/:id',
  ADMIN_TEAM: '/admin/team',
  ADMIN_ROLES: '/admin/roles',
  ADMIN_EQUIPMENT: '/admin/equipment',
  ADMIN_EQUIPMENT_DETAIL: '/admin/equipment/:id',
  ADMIN_EQUIPMENT_AVAILABILITY: '/admin/equipment/availability',
  ADMIN_VEHICLES: '/admin/vehicles',
  ADMIN_GRAPHICS: '/admin/graphics',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_NOTIFICATIONS: '/admin/notifications',
  ADMIN_NOTIFICATION_SETTINGS: '/admin/notification-settings',
  ADMIN_PROFILE: '/admin/profile',

  // Worker
  WORKER: '/worker',
  WORKER_TASK: '/worker/tasks/:id',
  WORKER_NOTIFICATIONS: '/worker/notifications',
  WORKER_JOBS: '/worker/jobs',
  WORKER_SCHEDULE: '/worker/schedule',
  WORKER_PROFILE: '/worker/profile',
  WORKER_ASSIGN: '/worker/assign',
  WORKER_GRAPHICS: '/worker/graphics',
} as const;

export function buildRoute(route: string, params: Record<string, string>): string {
  let result = route;
  for (const [key, value] of Object.entries(params)) {
    result = result.replace(`:${key}`, value);
  }
  return result;
}
